"use client";
import * as React from "react";
const SvgUnfoldLessFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 14.59 1.42 16l3.17-3.17L7.76 16l1.41-1.41L4.59 10zM9.18 1.41 7.76 0 4.59 3.17 1.42 0 0 1.41 4.59 6z" }));
export {
  SvgUnfoldLessFilled as default
};
